// import { makeObjGetter } from '../../utils';
import { shortObjValue } from '../../../utils/vuex'

// 账号信息
// const _info = makeObjGetter('info');

// const uid = _info('uid', 0);
// const nick = _info('nick', '');
// const mobile = _info('mobile', '');
// const logo = _info('logoSrc', '');

// 是否为已验证手机号用户
function isValid (state) {
    const { info } = state
    if (info && info.uid > 0 && info.isValidMobile > 0) {
        return true
    }
    return false
}

function isVip(state) {
    return state.info && state.info.vip
}

function isRealName(state) {
    return state.info && state.info.isRealName
}

function isTeacher(state) {
    const {teacher} = state
    return !!teacher && teacher.isTeacher > 0
}

export default {
    uid: shortObjValue('info/uid', 0),
    nick: shortObjValue('info/nick', ''),
    logo: shortObjValue('info/logoSrc', ''),
    mobile: shortObjValue('info/mobile', ''),
    isValid,
    isTeacher,
    isVip,
    isRealName
}
